import PharmacyCard from './PharmacyCard';

export default PharmacyCard;
